export const formatDate = (dateString) => {
  if (!dateString) return "--";
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  let date = new Date(dateString).toLocaleDateString(undefined, options);
  if (date === "Invalid Date") {
    return "--";
  } else {
    return date;
  }
};

/** Resolve the row ID from common resource person payload shapes. */
export const resourcePersonId = (person) =>
  person?.id ?? person?._id ?? person?.userId ?? null;

/** Resolve a display name from common resource person payload shapes. */
export const resourcePersonName = (person) =>
  person?.name ||
  [person?.firstName, person?.lastName].filter(Boolean).join(" ") ||
  person?.email ||
  "--";

/** Badge styling for a status value. */
export const statusBadgeClass = (status) => {
  switch (String(status || "").toUpperCase()) {
    case "ACTIVE":
      return "badge bg-success";
    case "DEACTIVATED":
    case "SUSPENDED":
    case "DISABLED":
      return "badge bg-danger";
    case "INVITED":
    case "PENDING":
      return "badge bg-warning text-dark";
    default:
      return "badge bg-secondary";
  }
};

/** Format a monetary value as Naira; falls back to the raw value when not numeric. */
export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "--";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  return `₦${num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

/** Resolve a display title from common resource payload shapes. */
export const resourceTitle = (item) =>
  item?.title ||
  item?.name ||
  item?.courseTitle ||
  item?.resourceTitle ||
  item?.bookTitle ||
  "Untitled resource";

/** Resolve a display name from common student payload shapes. */
export const studentDisplayName = (student) =>
  student?.name ||
  student?.fullName ||
  [student?.firstName, student?.lastName].filter(Boolean).join(" ") ||
  [student?.first_name, student?.last_name].filter(Boolean).join(" ") ||
  student?.email ||
  "--";

/** Resolve a progress percentage from common progress payload shapes. */
export const progressPercent = (item) => {
  const raw =
    item?.progress ??
    item?.progressPercent ??
    item?.percentage ??
    item?.completionRate;
  if (raw === null || raw === undefined || raw === "") return null;
  const num = Number(raw);
  if (Number.isNaN(num)) return null;
  return num <= 1 && num > 0 ? Math.round(num * 100) : Math.round(num);
};
